import React, { useEffect, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
// import { Scanner } from '@yudiel/react-qr-scanner';
import { Button, Input, message, Spin, Switch } from "antd";
import { QrcodeOutlined } from "@ant-design/icons";
import {
  useEntitlementByContractId,
  useRedemption,
} from "../../api/redemption";

type ConfirmationType = { uuid: string; code: string };
const RedemptionPage = () => {
  const [open, setOpen] = useState(false);
  const [contractId, setContractId] = useState<string>();
  const {
    data: entitlement,
    refetch,
    isLoading,
  } = useEntitlementByContractId(contractId);
  const { mutateAsync: redeem, isPending } = useRedemption();
  const [ids, setIds] = useState<string[]>([]);
  const [confirmationCodes, setConfirmationCodes] = useState<
    ConfirmationType[]
  >([]);

  useEffect(() => {
    if (contractId) {
      refetch();
    }
  }, [contractId]);

  const onDone = (result: any) => {
    const _contractId = result[0].rawValue.split(" ")[3];
    if (_contractId) {
      // setContractId('82-1726481538285')
      setContractId(_contractId);
    }
    setOpen(false);
  };

  const onchange = (selected: boolean, id: string) => {
    if (selected) {
      const _value = ids.find((_id: string) => _id === id);
      if (!_value) {
        setIds((prev) => [...prev, id]);
      }
    } else {
      setIds((prev) => {
        return prev.filter((_id) => _id !== id);
      });
    }
  };

  const handleSubmit = async () => {
    if (entitlement && entitlement.data && entitlement.data.data) {
      try {
        const _data = ids.map((id: string) => {
          const _entitlement = entitlement.data.data.entitlementDetail.find(
            (item: any) => item.uuid === id,
          );
          const _val = confirmationCodes.find(
            (item: ConfirmationType) => item.uuid === _entitlement.uuid,
          );
          return {
            agentId: entitlement.data.data.agentId,
            entitlementCode: _val?.code,
            entitlementDetailUuid: _entitlement.uuid,
            entitlementUuid: entitlement.data.data.uuid,
            redemptionDate: 1726236255830,
            redemptionType: 3,
            uuid: "10000000-1000-4000-8000-100000000000".replace(
              /[018]/g,
              (c) =>
                (
                  +c ^
                  (crypto.getRandomValues(new Uint8Array(1))[0] &
                    (15 >> (+c / 4)))
                ).toString(16),
            ),
          };
        });

        const result = await redeem(_data);

        message.success(result.data.description);
      } catch (err: any) {
        message.error("Operation failed.");
      }
    }
  };

  const handleConfirmationCodeChange = ({ uuid, code }: ConfirmationType) => {
    const _val = confirmationCodes.map(
      (item: ConfirmationType) => item.uuid === uuid,
    );

    if (!_val) {
      setConfirmationCodes((prev) => [...prev, { uuid, code }]);
    } else {
      const otherCodes = confirmationCodes.filter(
        (item: ConfirmationType) => item.uuid !== uuid,
      );
      setConfirmationCodes([...otherCodes, { uuid, code }]);
    }
  };
  return (
    <>
      <div
        className="w-[80vw] flex flex-col mt-4 md:hidden pr-2"
        style={{ height: "90vh" }}
      >
        {!open && (
          <Button
            style={{ width: "100%" }}
            type="primary"
            onClick={() => setOpen(true)}
            icon={<QrcodeOutlined />}
          >
            Scan QR Code
          </Button>
        )}
        {/* {open && <div><Scanner onScan={(result) => onDone(result)} /></div>} */}
        <div className="grid grid-col gap-2 divide-y my-4">
          {isLoading && <Spin className="pt-10" />}
          {entitlement &&
            entitlement.data &&
            entitlement.data.status === "failed" && (
              <div className="w-full h-[200px] flex justify-center items-center text-white text-2xl">
                Invalid QR code.
              </div>
            )}
          {!isLoading &&
            entitlement &&
            entitlement.data &&
            entitlement.data.data &&
            entitlement.data.data.entitlementDetail.map(
              (item: any, index: number) => {
                return (
                  <div className="flex flex-col gap-2">
                    <div key={item.uuid} className="flex justify-between pt-2">
                      <div className="font-bold text-white text-xl">
                        {item.inputName}
                      </div>
                      <Switch onChange={(e) => onchange(e, item.uuid)} />
                    </div>
                    {ids.find((id: string) => item.uuid === id) && (
                      <Input
                        key={`${item.uuid}-${index}`}
                        placeholder={`${item.inputName} for confirmation code`}
                        onChange={(e) =>
                          handleConfirmationCodeChange({
                            uuid: item.uuid,
                            code: e.target.value,
                          })
                        }
                      />
                    )}
                  </div>
                );
              },
            )}
        </div>
        {entitlement &&
          entitlement.data &&
          entitlement.data.data &&
          entitlement.data.data.entitlementDetail && (
            <div className="mt-auto">
              <Button
                loading={isPending}
                disabled={ids.length === 0}
                onClick={handleSubmit}
                type="primary"
                style={{ width: "100%" }}
              >{`${entitlement.data.data.entitlementDetail.length === ids.length ? "Redeem All" : "Redeem Selected"}`}</Button>
            </div>
          )}
        {/* } */}
      </div>
      <div
        className="hidden md:flex"
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: 100,
        }}
      >
        <div
          className="shadow-2xl"
          style={{
            width: "30%",
            alignSelf: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 250,
            fontFamily: "Poppins",
            padding: 20,
            borderRadius: 8.5,
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 22,
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              gap: 12,
            }}
          >
            <div style={{ fontFamily: "Poppins", fontSize: 22 }}>Error</div>
            <div style={{ textAlign: "center" }}>
              This feature is not available for computer. Please use either your{" "}
              <b>phone</b> or <b>tablet</b>.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithAuth(RedemptionPage);
